import React, { useState, useEffect } from 'react';
import { API_BASE } from '../config';

function Dashboard() {
    const [data, setData] = useState(null);

    useEffect(() => {
        fetch(`${API_BASE}/api/dashboard`)
            .then(response => response.json())
            .then(data => setData(data))
            .catch(error => console.error('Error fetching dashboard data:', error));
    }, []);

    const StatCard = ({ stat }) => (
        <div className="stat-card">
            <h4>{stat.name}</h4>
            <p className="stat-value">{stat.value}</p>
            {stat.change && (
                <span className={`stat-change ${stat.trend}`}>
                    {stat.change}
                </span>
            )}
        </div>
    );

    const ActivityItem = ({ activity }) => (
        <div className="activity-item">
            <div className={`activity-icon ${activity.type}`}></div>
            <div className="activity-content">
                <span className="activity-user">{activity.user}</span>
                {activity.action ? (
                    <span className="activity-action">{activity.action}</span>
                ) : activity.query ? (
                    <span className="activity-action">searched for "{activity.query}"</span>
                ) : (
                    <span className="activity-action">performed an action</span>
                )}
                {activity.title && <span className="activity-title">{activity.title}</span>}
                <span className="activity-time">{activity.time}</span>
            </div>
        </div>
    );

    return (
        <div className="dashboard">
            <h2>Research Dashboard</h2>
            {data ? (
                <div>
                    <div className="dashboard-header">
                        <h3>{data.message}</h3>
                        <div className="system-health">
                            <span className={`status-indicator ${data.systemHealth.apiStatus}`}>
                                API: {data.systemHealth.apiStatus}
                            </span>
                            <span className={`status-indicator ${data.systemHealth.databaseStatus}`}>
                                DB: {data.systemHealth.databaseStatus}
                            </span>
                        </div>
                    </div>

                    {/* Stats Grid */}
                    <div className="stats-grid">
                        {data.stats.map(stat => (
                            <StatCard key={stat.name} stat={stat} />
                        ))}
                    </div>

                    {/* Charts Section */}
                    <div className="charts-section">
                        <h4>Analytics Overview</h4>
                        <div className="charts-grid">
                            <div className="chart-card">
                                <h5>Search Trends</h5>
                                <div className="chart-placeholder">
                                    <div className="chart-bar" style={{height: '60%'}}></div>
                                    <div className="chart-bar" style={{height: '75%'}}></div>
                                    <div className="chart-bar" style={{height: '85%'}}></div>
                                    <div className="chart-bar" style={{height: '70%'}}></div>
                                    <div className="chart-bar" style={{height: '90%'}}></div>
                                    <div className="chart-bar" style={{height: '95%'}}></div>
                                </div>
                                <p>Monthly search volume increase</p>
                            </div>
                            
                            <div className="chart-card">
                                <h5>Article Categories</h5>
                                <div className="chart-placeholder">
                                    <div className="chart-pie">
                                        <div className="pie-slice" style={{background: '#3498db'}}></div>
                                        <div className="pie-slice" style={{background: '#2ecc71'}}></div>
                                        <div className="pie-slice" style={{background: '#f39c12'}}></div>
                                        <div className="pie-slice" style={{background: '#e74c3c'}}></div>
                                    </div>
                                </div>
                                <p>Distribution by research field</p>
                            </div>
                        </div>
                    </div>

                    {/* Recent Activity */}
                    <div className="activity-section">
                        <h4>Recent Activity</h4>
                        <div className="activity-list">
                            {data.recentActivity.map((activity, index) => (
                                <ActivityItem key={index} activity={activity} />
                            ))}
                        </div>
                    </div>

                    {/* Top Searches */}
                    <div className="top-searches">
                        <h4>Top Searches This Week</h4>
                        <div className="searches-list">
                            {data.topSearches.map((search, index) => (
                                <div key={index} className="search-item">
                                    <span className="search-term">{search.term}</span>
                                    <span className="search-count">{search.count.toLocaleString()} searches</span>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            ) : (
                <div className="loading">
                    <div className="spinner"></div>
                    <p>Loading dashboard data...</p>
                </div>
            )}
        </div>
    );
}

export default Dashboard;
